import React from 'react'
import { Link } from 'gatsby'
import classnames from 'classnames'

const navLinkProps = {
  className: 'menu-item',
  activeStyle: {
    color: '#F06600',
  },
}

// const DROPDOWN_LINKS = [
//   { value: '/historia/', label: 'Experterna berättar' },
//   { value: '/history-timeline/', label: 'Utforska historien' },
//   { value: '/den-langa-historien/', label: 'Den långa historien' },
//   { value: '/kallhanvisningar/', label: 'Källhänvisningar' },
// ]

const LINKS = [
  { value: '/behovet/', label: 'Behovet' },
  { value: '/visionen-new/', label: 'Visionen' },
  // { value: '/effekter/', label: 'Effekter' },
  { value: '/processen/', label: 'Processen' },
  { value: '/uppgiften/', label: 'Uppgiften' },
  { value: '/historia-new/', label: 'Historia' },
  { value: '/kontakta-oss/', label: 'Kontakta oss' },
  // { value: '/fragor-och-svar/', label: 'Frågor och svar' },
]

// class JHDropdown extends React.PureComponent {
//   state = {
//     open: false,
//     listRef: React.createRef(),
//     linkRef: React.createRef(),
//   }

//   componentDidMount() {
//     document.addEventListener('mousedown', this.handleClickOutside)

//     this.updateWindowDimensions()
//     window.addEventListener('resize', this.updateWindowDimensions)
//   }

//   componentWillUnmount() {
//     document.removeEventListener('mousedown', this.handleClickOutside)
//     window.removeEventListener('resize', this.updateWindowDimensions)
//   }

//   updateWindowDimensions = () => {
//     let vh = window.innerHeight * 0.01
//     document.documentElement.style.setProperty('--vh', `${vh}px`)
//   }

//   handleClickOutside = e => {
//     if (!this.state.open) return

//     const { current: listEl } = this.state.listRef
//     const { current: linkEl } = this.state.linkRef

//     if (
//       listEl &&
//       linkEl &&
//       !listEl.contains(e.target) &&
//       !linkEl.contains(e.target)
//     ) {
//       this.hideDropdown()
//     }
//   }

//   get dropdownClass() {
//     return classnames({
//       dropdown: true,
//       'dropdown-open': this.state.open,
//     })
//   }

//   get dropdownLinkClass() {
//     return classnames({
//       'menu-item menu-item-dropdown': true,
//       'menu-item-open': this.state.open,
//     })
//   }

//   toggleDropdownMenu = () => {
//     this.setState({ open: !this.state.open })
//   }

//   hideDropdown = () => {
//     this.setState({ open: false })
//   }

//   render() {
//     return (
//       <>
//         <div className={this.dropdownClass} ref={this.state.listRef}>
//           {DROPDOWN_LINKS.map(({ value, label }) => (
//             <Link
//               {...navLinkProps}
//               key={value}
//               to={value}
//               onClick={this.props.hideMenu}
//             >
//               {label}
//             </Link>
//           ))}
//         </div>
//         <a
//           className={this.dropdownLinkClass}
//           ref={this.state.linkRef}
//           onClick={this.toggleDropdownMenu}
//         >
//           Historia
//         </a>
//       </>
//     )
//   }
// }

export default class Header extends React.PureComponent {
  state = {
    showMenu: false,
    darkMenu: false,
  }

  toggleMenu = () => {
    this.setState({ showMenu: !this.state.showMenu })
  }

  hideMenu = () => {
    this.setState({ showMenu: false })
  }

  get menuClass() {
    return classnames({
      menu: true,
      'menu-open': this.state.showMenu,
    })
  }

  get burgerClass() {
    return classnames({
      'hamburger hamburger--vortex': true,
      'is-active': this.state.showMenu,
    })
  }

  get pathname() {
    if (!this.props.location) return ''

    return this.props.location.pathname
  }

  get headerClass() {
    const lightHeaderPaths = [
      '/',
      '/processen/',
      '/visionen-new/',
      '/kontakta-oss/',
      '/behovet/',
      '/effekter/',
      '/uppgiften/',
      '/history-timeline/',
      '/historia-new/',
    ]

    return classnames({
      header: true,
      'header-dark': !lightHeaderPaths.includes(this.pathname),
    })
  }

  render() {
    return (
      <div className={this.headerClass}>
        <Link to="/" className="header-logo" onClick={this.hideMenu}>
          <svg
            width="140"
            height="27"
            viewBox="0 0 140 27"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="none" fillRule="evenodd">
              <g transform="translate(-20 -15)" fill="#FFFFFE">
                <g transform="translate(20 15)">
                  <path d="M23.9105263,19.0298548 C23.4111111,19.5280399 22.7569591,19.7771325 22.1019883,19.7771325 C21.448655,19.7771325 20.7945029,19.5280399 20.2950877,19.0306715 L20.2926316,19.0290381 C19.2954386,18.0334846 19.2954386,16.4188748 20.294269,15.4225045 C20.7928655,14.9243194 21.4478363,14.6752269 22.1019883,14.6752269 C22.7569591,14.6752269 23.4111111,14.9243194 23.9105263,15.4225045 C24.9093567,16.4188748 24.9093567,18.0343013 23.9105263,19.0298548 Z M14.9022222,11.2459165 C12.5042105,11.2459165 10.5597661,9.30626134 10.5597661,6.91333938 C10.5597661,4.52123412 12.5042105,2.58157895 14.9022222,2.58157895 C17.3010526,2.58157895 19.2454971,4.52123412 19.2454971,6.91333938 C19.2454971,9.30626134 17.3010526,11.2459165 14.9022222,11.2459165 Z M9.83847953,18.4132486 C9.40783626,19.8416515 8.09298246,20.7637024 6.67087719,20.7637024 C6.3548538,20.7637024 6.03391813,20.718784 5.71625731,20.6232305 C3.96584795,20.0980944 2.97438596,18.2572595 3.50081871,16.5111615 C3.93146199,15.0827586 5.24631579,14.1607078 6.66842105,14.1598911 C6.98362573,14.1598911 7.30538012,14.2056261 7.62304094,14.3011797 C9.37345029,14.8271325 10.3649123,16.6679673 9.83847953,18.4132486 Z M2.39883041,8.89627949 C2.15321637,8.16533575 2.54783626,7.37477314 3.27976608,7.12976407 C3.4271345,7.07994555 3.57695906,7.05626134 3.7251462,7.05626134 C4.3097076,7.05626134 4.85497076,7.42459165 5.05064327,8.00771325 C5.29707602,8.73865699 4.90245614,9.5292196 4.1697076,9.77422868 C4.02233918,9.82404719 3.87251462,9.8477314 3.7251462,9.8477314 C3.1405848,9.8477314 2.59532164,9.47940109 2.39883041,8.89627949 Z M25.2679532,14.0692377 C24.4222222,13.2255898 23.2981287,12.7608893 22.1019883,12.7608893 C20.9066667,12.7608893 19.7825731,13.2255898 18.9368421,14.0692377 C18.0911111,14.912069 17.6260819,16.0333938 17.6260819,17.226588 C17.6260819,18.1045372 17.8807018,18.9449183 18.3522807,19.6636116 L15.8265497,22.1823049 L15.8265497,13.0916515 C18.8426901,12.6441016 21.1637427,10.0437387 21.1637427,6.91333938 C21.1637427,3.4685118 18.3547368,0.667241379 14.9022222,0.667241379 C11.4497076,0.667241379 8.64070175,3.4685118 8.64070175,6.91333938 C8.64070175,10.0437387 10.9617544,12.6441016 13.9778947,13.0916515 L13.9778947,18.6215064 L11.8705263,17.9893829 C12.1185965,15.553176 10.611345,13.1986388 8.17567251,12.4685118 C7.68526316,12.3206897 7.17766082,12.2463702 6.66842105,12.2463702 C6.43754386,12.2463702 6.20339181,12.2798548 5.97988304,12.3100726 C5.97988304,12.3100726 5.98070175,12.2790381 5.9651462,12.2324864 C5.95122807,12.1892015 5.68596491,11.3921053 5.60163743,11.1430127 C5.58690058,11.096461 5.57134503,11.06951 5.56643275,11.061343 C6.69298246,10.2699637 7.21859649,8.80480944 6.75847953,7.43684211 C6.32046784,6.13421053 5.10140351,5.26034483 3.7251462,5.26034483 C3.37883041,5.26034483 3.03578947,5.31588022 2.70666667,5.4261343 C1.89614035,5.69809437 1.24035088,6.26733212 0.860467836,7.03094374 C0.479766082,7.79373866 0.42,8.65943739 0.691812865,9.46796733 C1.12982456,10.7697822 2.34807018,11.6436479 3.7251462,11.6436479 C3.75789474,11.6436479 3.79146199,11.6428312 3.82421053,11.6420145 C3.82584795,11.654265 3.82912281,11.6803993 3.84140351,11.7155172 C3.91754386,11.9417423 4.17625731,12.7151543 4.19263158,12.7641561 C4.21309942,12.823775 4.23602339,12.842559 4.23602339,12.842559 C3.03005848,13.4844828 2.07216374,14.6041742 1.66362573,15.9590744 C1.26081871,17.2935572 1.40327485,18.7039927 2.06397661,19.9314882 C2.72549708,21.158167 3.82584795,22.0549002 5.16280702,22.4567151 C5.65403509,22.6037205 6.16081871,22.6780399 6.67087719,22.6780399 C8.66853801,22.6780399 10.4901754,21.5134301 11.3596491,19.7624319 L13.9778947,20.5480944 L13.9778947,26.7231397 L15.8265497,26.7231397 L15.8265497,24.6054446 C15.8265497,24.6054446 16.2678363,24.2583485 16.6821053,23.8459165 C17.0963743,23.4326679 19.6597661,20.9670599 19.6597661,20.9670599 C20.3802339,21.4374773 21.2210526,21.6914701 22.1019883,21.6914701 C23.2981287,21.6914701 24.4222222,21.2275862 25.2679532,20.3831216 C27.0126316,18.6427405 27.0126316,15.8104356 25.2679532,14.0692377 Z" />
                  <path d="M131.496023,17.3931942 C132.862456,15.9027223 133.402807,15.696098 134.099532,15.696098 L134.615322,15.696098 C136.470526,15.696098 136.907719,17.342559 136.907719,18.3193285 L136.907719,26.7264065 L139.769942,26.7264065 L139.769942,18.3193285 C139.769942,14.1541742 136.960117,12.9201452 134.615322,12.9201452 L133.73848,12.9201452 C132.862456,12.9201452 132.037193,13.4346642 131.238947,14.1280399 L131.058012,13.4085299 C130.980234,13.1512704 130.748538,13.023049 130.413684,13.023049 L128.60924,13.023049 L128.60924,26.7264065 L131.496023,26.7264065 L131.496023,17.3931942 Z M121.547836,15.696098 C123.042807,15.696098 123.583977,17.0844828 123.737895,18.2678766 L118.171462,18.2678766 C118.326199,17.0844828 118.867368,15.696098 120.387719,15.696098 L121.547836,15.696098 Z M120.387719,24.1554446 C118.532515,24.1554446 118.145263,22.1235027 118.145263,20.8135209 L126.728655,20.8135209 L126.728655,19.2446461 C126.728655,14.5396552 123.841053,12.9201452 121.470058,12.9201452 L120.490877,12.9201452 C118.093684,12.9201452 115.207719,14.5396552 115.207719,19.2446461 L115.207719,20.6077132 C115.207719,25.3380218 118.093684,26.9575318 120.490877,26.9575318 L121.650994,26.9575318 C123.42924,26.9575318 125.568538,25.9807623 126.419181,23.0243194 L123.558596,22.3554446 C123.196725,23.3330309 122.810292,24.1554446 121.779532,24.1554446 L120.387719,24.1554446 Z M110.07848,21.815608 C110.336374,21.8923775 110.774386,22.1757713 110.774386,22.7409256 C110.774386,23.5641561 110.00152,24.1554446 109.176257,24.1554446 L107.99076,24.1554446 C106.856842,24.1554446 106.237895,23.049637 106.057778,22.3039927 L103.119415,22.9720508 C103.686784,24.9010889 105.077778,26.9575318 107.96538,26.9575318 L109.150877,26.9575318 C111.59883,26.9575318 113.789708,25.2604356 113.789708,22.8438294 L113.789708,22.4583485 C113.789708,21.7127042 113.326316,19.6815789 111.006082,19.0388385 L107.192515,17.9852995 C107.011579,17.9330309 106.418012,17.7533575 106.418012,17.0338475 C106.418012,16.2359347 107.089357,15.696098 107.96538,15.696098 L108.841404,15.696098 C110.053099,15.696098 110.516491,16.9056261 110.672047,17.5214156 L113.635789,16.8786751 C113.223158,15.0541742 111.625029,12.9201452 108.866784,12.9201452 L108.068538,12.9201452 C105.593567,12.9201452 103.403509,14.6172414 103.403509,16.9815789 L103.403509,17.3678766 C103.403509,18.1649728 103.892281,20.0678766 106.057778,20.6844828 L110.07848,21.815608 Z M95.9294737,24.1554446 C94.0734503,24.1554446 93.6608187,22.5098004 93.6608187,21.5583485 L93.6608187,13.1512704 L90.7740351,13.1512704 L90.7740351,21.5583485 C90.7740351,25.6973684 93.6100585,26.9575318 95.9294737,26.9575318 L96.5729825,26.9575318 C97.4498246,26.9575318 98.274269,26.4430127 99.0733333,25.7235027 L99.2534503,26.3401089 C99.3312281,26.5981851 99.4597661,26.7264065 99.8977778,26.7264065 L101.701404,26.7264065 L101.701404,13.1512704 L98.8154386,13.1512704 L98.8154386,22.4583485 C97.4498246,23.949637 96.908655,24.1554446 96.2119298,24.1554446 L95.9294737,24.1554446 Z M80.645731,17.3931942 C82.011345,15.9027223 82.5525146,15.696098 83.2484211,15.696098 L83.7642105,15.696098 C85.6194152,15.696098 86.0582456,17.342559 86.0582456,18.3193285 L86.0582456,26.7517241 L88.9188304,26.7517241 L88.9188304,18.3193285 C88.9188304,14.1541742 86.1090058,12.9201452 83.7642105,12.9201452 L82.8873684,12.9201452 C82.0883041,12.9201452 81.3408187,13.3317604 80.645731,13.9222323 L80.645731,8.11225045 L77.7581287,8.11225045 L77.7581287,26.7264065 L80.645731,26.7264065 L80.645731,17.3931942 Z M67.5012865,17.3931942 C68.8669006,15.9027223 69.4080702,15.696098 70.1039766,15.696098 L70.6197661,15.696098 C72.4749708,15.696098 72.9129825,17.342559 72.9129825,18.3193285 L72.9129825,26.7264065 L75.774386,26.7264065 L75.774386,18.3193285 C75.774386,14.1541742 72.9645614,12.9201452 70.6197661,12.9201452 L69.742924,12.9201452 C68.8669006,12.9201452 68.0424561,13.4346642 67.2433918,14.1280399 L67.0624561,13.4085299 C66.9854971,13.1512704 66.7538012,13.023049 66.4181287,13.023049 L64.6145029,13.023049 L64.6145029,26.7264065 L67.5012865,26.7264065 L67.5012865,17.3931942 Z M58.6861988,17.5990018 C60.0526316,16.1077132 60.5938012,15.9027223 61.2897076,15.9027223 L62.9909942,15.9027223 L62.9909942,12.9201452 L60.928655,12.9201452 C60.0788304,12.9201452 59.2535673,13.5375681 58.4545029,14.2562613 L58.222807,13.357078 C58.1712281,13.1006352 57.9133333,13.023049 57.6038596,13.023049 L55.8002339,13.023049 L55.8002339,26.7264065 L58.6861988,26.7264065 L58.6861988,17.5990018 Z M48.7895906,15.696098 C50.2845614,15.696098 50.825731,17.0844828 50.9804678,18.2678766 L45.4132164,18.2678766 C45.5679532,17.0844828 46.1091228,15.696098 47.6294737,15.696098 L48.7895906,15.696098 Z M47.6294737,24.1554446 C45.7734503,24.1554446 45.3878363,22.1235027 45.3878363,20.8135209 L53.9695906,20.8135209 L53.9695906,19.2446461 C53.9695906,14.5396552 51.0836257,12.9201452 48.7118129,12.9201452 L47.7326316,12.9201452 C45.3354386,12.9201452 42.4494737,14.5396552 42.4494737,19.2446461 L42.4494737,20.6077132 C42.4494737,25.3380218 45.3354386,26.9575318 47.7326316,26.9575318 L48.8927485,26.9575318 C50.6709942,26.9575318 52.8102924,25.9807623 53.6609357,23.0243194 L50.8003509,22.3554446 C50.4392982,23.3330309 50.0520468,24.1554446 49.0212865,24.1554446 L47.6294737,24.1554446 Z M40.722807,8.78030853 L33.6859649,8.78030853 L33.6859649,11.4288566 L37.7328655,11.4288566 L37.7328655,20.7359347 C37.7328655,22.0467332 37.3202339,24.0786751 35.4650292,24.0786751 L34.5366082,24.0786751 C33.0678363,24.0786751 32.3981287,22.9467332 32.037076,21.6865699 L29.0471345,22.3554446 C29.9493567,25.8525408 32.3719298,26.9575318 34.5366082,26.9575318 L35.4650292,26.9575318 C37.8360234,26.9575318 40.722807,25.5176951 40.722807,20.6077132 L40.722807,8.78030853 Z" />
                </g>
              </g>
            </g>
          </svg>
        </Link>
        <div className={this.menuClass}>
          {/* <JHDropdown hideMenu={this.hideMenu} /> */}
          {LINKS.map(({ value, label }) => (
            <Link
              {...navLinkProps}
              key={value}
              to={value}
              onClick={this.hideMenu}
            >
              {label}
            </Link>
          ))}
        </div>
        <button
          className={this.burgerClass}
          type="button"
          onClick={this.toggleMenu}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>
    )
  }
}
